import Vue from "vue"

import signupApi from "../../api/signup"
//import utilsApi from "../../api/utils"

import utils from "@/utils/utils"

const initialObject = {
  username: undefined,
  first_name: undefined,
  last_name: undefined,
  password: undefined,
  phone: undefined,
  email: undefined,
  email_confirmation: undefined,
  role: "admin"
}

const initialObjectWebsite = {
  currencies: [],
  owner: undefined,
  name: undefined,
  domain: undefined,
  default_locale: {},
  locales: [],
  total_orders: 0,
  algolia_index: true,
  alert: { status: false, body: undefined },
  status: "published",
  config: {
    shop: { active: true },
    blog: { active: true },
    messaging: {},
    facebook: {},
    google: {},
    algolia: {},
    defaultPages: { home: "home" },
    paymentMethods: [],
    shippingMethods: [
      {
        name: "flat",
        responseTemplate: { total: "value" },
        price: { COP: 20000, USD: 15 }
      }
    ]
  },
  mail_config: {
    domain: "mail.quantic.works",
    host: "api.mailgun.net",
    contactMail: "info@quantic.works",
    from: "Quantic <info@quantic.works>"
  },
  business: {
    short_name: undefined,
    name: undefined,
    description: undefined,
    telephone: undefined,
    email: undefined,
    address: {
      address: "undefined",
      province: "undefined",
      city: "undefined",
      post_code: 111111,
      country: {
        nombre: "Colombia",
        name: "Colombia",
        nom: "Colombie",
        iso2: "CO",
        iso3: "COL",
        phone_code: 57
      }
    },
    openingHours: "Mo, Tu, We, Th 09:00-18:00 Fr 08:00-17:00 Sa 10:00-15:00",
    theme_color: "#4D49EF",
    background_color: "#4D49EF"
  },
  head: "{}",
  manifest: "{}"
}

const initialState = {
  user: {},
  account: initialObject,
  website: initialObjectWebsite,
  logged: false,
  error: false
}

const state = Object.assign({}, initialState)

const getters = {
  user: (state) => state.user,
  logged: (state) => state.logged,
  signupIndex: (state) => (payload) => {
    //const { param, parent, key } = payload || {}
    return utils.digger(state, payload)
  }
}
const actions = {
  UPDATE_signup({ commit }, payload) {
    commit("SET_signup", payload)
    return true
  },
  async UPDATE_ACCOUNT({ commit }, object) {
    let apiResponse = await signupApi.updateAccount(object)
    if (apiResponse != null) {
      localStorage.setItem("klausToken", apiResponse.auth_token)
      commit("LOG_IN_OK", apiResponse)
      return true
    } else {
      commit("LOG_IN_ERROR", {})
      return false
    }
  },
  async LINK_SITE({ commit, state }) {
    //console.log("Object before api", object)
    let apiResponse = await signupApi.linkSite(state.website)
    if (apiResponse != null) {
      commit("SUCCESS", true)
      return true
    } else {
      commit("SUCCESS", false)
      return false
    }
  },
  async CREATE_ACCOUNT({ state, commit, dispatch }) {
    let apiResponse = await signupApi.createAccount(state.account)
    if (apiResponse != null && !apiResponse.error) {
      localStorage.setItem("klausToken", apiResponse.auth_token)
      commit("SET_signup", {
        param: "website",
        key: "owner",
        value: apiResponse.account.id
      })

      commit("LOG_IN_OK", { user: apiResponse.account })
      return true
    } else {
      //console.log("CREATE ACCOUNT ERROR ", apiResponse)
      const notification = {
        active: true,
        type: "ERROR",
        content: {
          title: "ERROR",
          message: apiResponse.error.message
        }
      }
      commit("LOG_IN_ERROR", {})
      dispatch("UPDATE_general", {
        param: "loading",
        key: "active",
        value: false
      })
      dispatch("UPDATE_general", {
        param: "notifications",
        value: notification
      })
      return false
    }
  },
  LOG_OUT({ commit /* dispatch */ }) {
    localStorage.setItem("klausToken", "")
    commit("LOG_IN_ERROR", {})

    return true
  },
  async INIT_APP({ dispatch, commit }) {
    // se verifica que en el localhost memoria tenga nuestro token,
    //si es asi,obtenemos el usuario.
    let preToken = localStorage.getItem("klausToken")

    if (preToken) {
      const apiResponse = await signupApi.getUserWithToken(preToken)
      dispatch("UPDATE_general", {
        param: "loading",
        key: "active",
        value: true
      })

      if (apiResponse != null && apiResponse.user.site) {
        const cachedLocaleId = localStorage.getItem("locale-id")
        const initialLocale =
          apiResponse.user.site.locales.find((l) => l.id === cachedLocaleId) ??
          apiResponse.user.site.locales[0]

        commit("LOG_IN_OK", apiResponse)
        dispatch("INIT_site", apiResponse.user.site)
        dispatch("CHANGE_LOCALE", initialLocale)
        dispatch("UPDATE_general", {
          param: "loading",
          key: "active",
          value: false
        })

        return true
      } else {
        //commit("LOG_IN_ERROR", {})
        dispatch("UPDATE_general", {
          param: "loading",
          key: "active",
          value: false
        })
      }
    }
  },
  async LOG_IN({ dispatch, commit }, credentials) {
    const apiResponse = await signupApi.logIn(
      credentials.username,
      credentials.pass
    )

    //console.log("Apoi response", apiResponse)
    if (apiResponse != null) {
      localStorage.setItem("klausToken", apiResponse.auth_token)

      const cachedLocaleId = localStorage.getItem("locale-id")
      const initialLocale =
        apiResponse.user.site.locales.find((l) => l.id === cachedLocaleId) ??
        apiResponse.user.site.locales[0]

      commit("LOG_IN_OK", apiResponse)
      dispatch("INIT_site", apiResponse.user.site)
      dispatch("CHANGE_LOCALE", initialLocale)
      return true
    } else {
      commit("LOG_IN_ERROR", {})
      return false
    }
  },
  async RESET_PASSWORD({ commit }, credentials) {
    const apiResponse = await signupApi.resetPassword(
      credentials.username,
      credentials.pass,
      credentials.passVerified
    )

    //console.log("Apoi response", apiResponse)
    if (apiResponse != null) {
      localStorage.setItem("klausToken", apiResponse.auth_token)
      commit("LOG_IN_OK", apiResponse)
    } else {
      commit("LOG_IN_ERROR", {})
    }
  },
  async CLEAN_STORE_signup({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_signup", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  }
}
const mutations = {
  ACCOUNT_SETTING: (state, { user }) => {
    state.user = user
    state.error = false
  },
  ACCOUNT_ERROR: (state) => {
    //state.user = null
    state.error = true
  },
  LOG_IN_OK: (state, { user }) => {
    state.user = user
    state.logged = true
    state.error = false
  },
  LOG_IN_ERROR: (state, user) => {
    state.user = user
    state.logged = false
    state.error = true
  },
  SUCCESS: (state, succes) => {
    state.error = !succes
  },
  SET_signup: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
